     getLocation();
     function getLocation() {
      //eraseCookie('india_login');
    	fetch('https://ipinfo.io/json?token=391aa40373c023')
      .then(res => res.json())
      .then(response => {
        if (response.country == "IN" || response.country == "CN") { 
            //console.log('india');
    			var x = getCookie('india_login');
    			if (!x) {
                if(Shopify.designMode){
                  return;
                }
                window.location = "https://porthomall.com/pages/login-password";
    			}
    		}
    	}).catch((data, status) => {
    		//console.log('Request failed', data)
    	})
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null
  }

  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
  }